// RouteError.js
import React from 'react';
import { useNavigate, useRouteError } from 'react-router-dom';

const RouteError = () => {
  const navigate = useNavigate();
  const error = useRouteError();

  const handleRetry = () => {
    navigate(0); 
  };

  const handleLogin = () => {
    navigate('/'); 
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Oops! Something went wrong.</h1>
      <p style={styles.message}>{error?.statusText || "An unexpected error occurred."}</p>
      <div style={styles.buttonContainer}>
        <button style={styles.retryButton} onClick={handleRetry}>Retry</button>
        <button style={styles.loginButton} onClick={handleLogin}>Go to Login</button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundColor: 'rgba(193,224,255,0.7)',
    color: '#333',
    padding: '20px',
    fontFamily: "'Poppins', sans-serif",
  },
  heading: {
    fontSize: '2.5rem',
    fontWeight: 'bold',
    color: '#d9534f',
    marginBottom: '10px',
  },
  message: {
    fontSize: '1.2rem',
    color: '#6c757d',
    marginBottom: '20px',
    textAlign: 'center',
    maxWidth: '500px',
  },
  buttonContainer: {
    display: 'flex',
    gap: '10px',
  },
  retryButton: {
    backgroundColor: '#5bc0de',
    color: '#fff',
    border: 'none',
    padding: '10px 20px',
    fontSize: '1rem',
    fontWeight: 'bold',
    cursor: 'pointer',
    borderRadius: '5px',
    transition: 'background-color 0.3s ease',
  },
  loginButton: {
    backgroundColor: '#0275d8',
    color: '#fff',
    border: 'none',
    padding: '10px 20px',
    fontSize: '1rem',
    fontWeight: 'bold',
    cursor: 'pointer',
    borderRadius: '5px',
    transition: 'background-color 0.3s ease',
  }
};

export default RouteError;
